import { CHANNELS } from "../shared/channels";
import { BudgetDraft, BudgetKind } from "../shared/types";
import { call } from "./bridge";
import { byId, flashToast } from "./dom";
import { loadShareBoard, onSharedChange } from "./shares";
import { canUse } from "./me";
import { t } from "./i18n";

// a quick way onto a budget from home: a cost, bill or money in, into mine or into someone's who lets me add to theirs

let kind: BudgetKind = "cost";
// whose budget, empty for my own
let owner = "";
let owners: Array<{ id: string; name: string }> = [];

function paintKind(): void {
  byId("today-money-kind").querySelectorAll<HTMLElement>("[data-kind]").forEach((item) => item.classList.toggle("active", item.dataset.kind === kind));
  byId("today-money-name").setAttribute("placeholder", t({ income: "where it came from", bill: "rent, phone…", cost: "what was it" }[kind as "income" | "bill" | "cost"]));
}

function paintOwners(): void {
  const mine = canUse("budget", "edit");
  const options = [...(mine ? [{ id: "", name: t("mine") }] : []), ...owners.map((person) => ({ id: person.id, name: t("{name}'s", { name: person.name.toLowerCase() }) }))];
  if (!options.some((option) => option.id === owner)) owner = options[0]?.id ?? "";
  byId("today-money").closest<HTMLElement>(".mod")!.hidden = !options.length;
  const box = byId("today-money-owner");
  box.hidden = options.length < 2;
  box.replaceChildren(...options.map((option) => {
    const key = document.createElement("button");
    key.type = "button";
    key.className = "seg-option";
    key.classList.toggle("active", option.id === owner);
    key.textContent = option.name;
    key.addEventListener("click", () => {
      owner = option.id;
      paintOwners();
    });
    return key;
  }));
}

async function loadOwners(): Promise<void> {
  const board = await loadShareBoard(true);
  owners = board.withMe.filter((person) => person.kinds.includes("budget-add")).map(({ id, name }) => ({ id, name }));
  paintOwners();
}

async function submit(event: Event): Promise<void> {
  event.preventDefault();
  const name = byId<HTMLInputElement>("today-money-name");
  const amount = byId<HTMLInputElement>("today-money-amount");
  if (!name.value.trim()) return name.focus();
  if (!amount.value.trim()) return amount.focus();
  const draft: BudgetDraft = {
    kind,
    name: name.value,
    amount: amount.value,
    total: 0,
    repeat: byId<HTMLInputElement>("today-money-monthly").checked ? "monthly" : "once",
    date: "",
    by: "",
    category: ""
  };
  try {
    await (owner ? call(CHANNELS.budgetSharedSave, owner, draft) : call(CHANNELS.budgetSave, draft));
    flashToast(owner ? t("added to {name}'s budget", { name: owners.find((person) => person.id === owner)?.name || "" }) : t("added to your budget"));
    name.value = "";
    amount.value = "";
  } catch (error) {
    flashToast(error instanceof Error ? error.message.replace(/^.*Error: /, "") : t("couldn't add that"));
  }
}

export function setupBudgetQuick(): void {
  byId("today-money-kind").addEventListener("click", (event) => {
    const option = (event.target as Element).closest<HTMLElement>("[data-kind]");
    if (!option) return;
    kind = option.dataset.kind as BudgetKind;
    // bills usually come back every month, a cost or money in usually doesn't
    byId<HTMLInputElement>("today-money-monthly").checked = kind === "bill";
    paintKind();
  });
  byId("today-money-form").addEventListener("submit", (event) => void submit(event));
  onSharedChange("budget", () => void loadOwners().catch(() => undefined));
  paintKind();
}

export function refreshBudgetQuick(): void {
  void loadOwners().catch(() => undefined);
}
